import { useEffect, useRef } from "react";

interface VideoBackgroundProps {
  src: string;
  className?: string;
  onEnded?: () => void;
  loop?: boolean;
}

export function VideoBackground({ src, className = "", onEnded, loop }: VideoBackgroundProps) {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    videoRef.current?.play();
  }, []);

  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}>
      <video
        ref={videoRef}
        src={src}
        muted
        playsInline
        preload="auto"
        onEnded={onEnded}
        loop={loop}
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/40" />
    </div>
  );
}
